<template lang="pug">
.wrapper.pt-header65
  header.gheader.-white.gheader-fix
    .hedder_wrap
      .gheader__link-back
        a(v-on:click="goBack") 戻る
  .safety-confirmation-container
    .safety-confirmation-header(v-if="isExist && isTraining")
      p こちらは訓練です
    .wifi-section
    .safety-confirmation-content
      .safety-confirmation-checkbox
        input(type="checkbox" v-model="isSafety" id="isSafety" name="isSafety")
        label(for="isSafety") 家族全員無事です
      .can-go-checkbox
        input(type="checkbox" v-model="canHelp" id="canHelp" name="canHelp")
        label(for="canHelp") 安全が確認でき次第、出社可能
      .report
        label 報告事項（任意）
        textarea(v-model="comment", placeholder="例）家族で○○小学校に避難中\n自宅前の道路は冠水のため走行不可等" rows=5)
      p.text-center.text-sent-at(v-if="sentAt") {{sentAt}}送信済み
    .safety-confirmation-footer
      .footer-content.text-center
        p 安全確保を最優先に行動すること！
        button.send-button(v-on:click="sendSafetyConfirmation" :disabled="isExist ? false : 'disabled'") 送信する
        span(v-if="!isExist") 現在は送信できません

</template>
<script>
export default {
  name: 'service-answer-edit',
  created () {
    console.log('created')
    this.initialize()
  },
  data () {
    return {
      isExist: false,
      isTraining: false,
      isSearchEnd: false,
      isSafety: false,
      canHelp: false,
      sentAt: null,
      comment: ''
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    }
  },
  methods: {
    async initialize () {
      let res = await this.$store.dispatch('GET_SAFETY_CONFIRMATION_ANSWER')
      .catch(err => {
        console.log(err)
        return
      })
      if (res && res.data) {
        this.isSafety = res.data.attributes['is-safety'] || false
        this.canHelp = res.data.attributes['can-help'] || false
        this.comment = res.data.attributes['comment']
        this.isTraining = res.data.attributes['is-training']
        this.sentAt = res.data.attributes['sent-at']
        this.isExist = true
      } else {
        this.isExist = false
      }
    },
    sendSafetyConfirmation: async function () {
      const data = {
        is_safety: this.isSafety,
        can_help: this.canHelp,
        comment: this.comment
      }
      const res = await this.$store.dispatch('UPDATE_SAFETY_CONFIRMATION_ANSWER', {data: data})
      .catch(err => {
        console.log(err)
        return
      })
      if (res) {
        window.alert('安否報告を送信しました。')
      }
    },
    goBack () {
      // 戻る
      this.$router.push({ path: '/' })
    }
  }
}
</script>
<style scoped>
.safety-confirmation-container {
    margin: 0 auto;
    background-color: #F9EDCA;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    max-width: 640px;
    padding-bottom: 80px;
}
.safety-confirmation-header {
    background-color: #FF0000;
    text-align: center;
    padding: 18px 0;
    height: 70px;
}
.safety-confirmation-header > p {
    font-size: 24px;
    font-weight: bold;
    color: #fff;
}
.safety-confirmation-content {
    padding: 32px 38px 0px;
}
.wifi-section {
    background-image: url('./images/wifi.png');
    background-size: cover;
    background-position: center;
    height: 200px; /* 必要に応じて高さを調整してください */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #333;
}
/* パソコン表示での高さ */
@media (min-width: 768px) {
    .wifi-section {
        height: 320px;
    }
}
.safety-confirmation-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to right, #1989F0, #12AFDF); /* 青いグラデーション */
    padding: 10px;
    border-radius: 8px;
    height: 70px;
}
.safety-confirmation-checkbox input {
    margin-right: 10px;
}
.safety-confirmation-checkbox label {
    color: white; /* テキストの色を白に設定 */
    font-weight: normal; /* 太字に設定 */
    font-size: 16px;
}

.can-go-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F8BB00;
    padding: 10px;
    border-radius: 8px;
    height: 70px;
    margin: 10px 0px;
}
.can-go-checkbox input {
    margin-right: 10px;
}
.can-go-checkbox label {
    color: white; /* テキストの色を白に設定 */
    font-weight: normal; /* 太字に設定 */
    font-size: 16px;
}
.button {
    display: inline-block;
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: #fff;
    text-align: center;
    text-decoration: none;
    border-radius: 8px;
    margin-bottom: 20px;
}
.report textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
}
.report label {
  margin: 13px auto 8px;
}
.text-sent-at {
  font-weight: bold;
  margin: 20px auto;
}
.safety-confirmation-footer {
    padding: 16px;
}
.footer-content {
    background-color: #fff;
    padding: 20px 27px;
    text-align: center;
    border: 1px solid #ff0000;
}
.footer-content > p {
    font-size: 18px;
    font-weight: bold;
    color: #ff0000;
}
.footer-content > span {
    color: #333;
}
.send-button {
    display: block;
    margin: 20px 0px;
    height: 50px;
    padding: 14px;
    color: #fff;
    text-align: center;
    text-decoration: none;
    font-size: 16px;
    border: 1px solid #ff0000;
    width: 100%;
    background: url(./images/circle_arrow.png) no-repeat right 16px center;
    background-color: #ff0000;
    background-size: 30px;
}
.send-button:disabled {
  background: #ccc;
    border: 1px solid #ccc;
}
</style>


// WEBPACK FOOTER //
// SafetyConfirmationEdit.vue?5baf57ff